import { createApi } from "@reduxjs/toolkit/query/react";

import { axiosBaseQuery } from "./axiosBaseQuery";

export const ssoApi = createApi({
  reducerPath: "ssoApi",
  baseQuery: axiosBaseQuery(),
  endpoints: () => ({}),
});
